import { type Mode } from '@libraries/typescript/api_client';

export const RUN_METADATA_REFRESH_MS = 5000;
export const ADMIN_AGENT_DRAFT_SESSION_KEY = 'admin-agent-draft-chat';
export const DEFAULT_ADMIN_AGENT_ORGANIZATION_NAME = 'Phoebe Home Care';

export function isDefaultAdminAgentOrganization(organization: {
    readonly internal_name?: string | null;
    readonly name?: string | null;
}): boolean {
    const organizationName = organization.name?.trim().toLowerCase();
    const organizationInternalName = organization.internal_name
        ?.trim()
        .toLowerCase();
    const targetName = DEFAULT_ADMIN_AGENT_ORGANIZATION_NAME.toLowerCase();

    return (
        organizationName === targetName ||
        organizationInternalName === targetName
    );
}

export function isMode(value: string): value is Mode {
    return value === 'live' || value === 'sandbox';
}
